import {eventEmitter, lang, sessid} from '../common/baseData';
import langData from './lang'

export class ProductCompareAll {
    constructor(params) {
        this.urlRequest = '/local/components/webhome/catalog.compare.result.section/ajax.php';
        this.comparedItems = [];
        this.nodeList = {};
        this.dataList = {};
        this.activeDropdown = null;
    }

    getMessage (message) {
        return langData[lang][message] || ''
    }

    initProductSelector(containerId) {
        const container = document.getElementById(containerId);
        if (!container) return;

        const selectsContainer = container.querySelector('#selects-container');
        const addButtonWrapper = container.querySelector('#add-button-wrapper');
        const addButton = container.querySelector('#add-to-compare-btn');
        const params = JSON.parse(atob(container.dataset.params));

        let selectedProduct = null;
        let self = this;

        // загружаем корневые разделы
        this.loadSections(0, 0, params.iblockId, selectsContainer);

        // закрытие дропдауна при клике вне его
        document.addEventListener('click', function(e) {
            if (!e.target.closest('.custom-select')) {
                self.closeAllDropdowns();
            }
        });

        // делегирование событий для дропдаунов
        selectsContainer.addEventListener('click', function(e) {
            // клик по триггеру (открытие/закрытие)
            if (e.target.closest('.custom-select-trigger')) {
                e.stopPropagation();
                const customSelect = e.target.closest('.custom-select');
                self.toggleDropdown(customSelect);
                return;
            }

            // клик по опции
            if (e.target.closest('.custom-select-option')) {
                e.stopPropagation();
                const option = e.target.closest('.custom-select-option');
                const customSelect = option.closest('.custom-select');
                const level = parseInt(customSelect.dataset.level);
                const selectedId = option.dataset.value;
                const type = option.dataset.type;
                const selectedText = option.textContent;

                // обновляем триггер
                const trigger = customSelect.querySelector('.custom-select-trigger span');
                trigger.textContent = selectedText;

                self.closeDropdown(customSelect);

                self.removeSelectsAfterLevel(level, selectsContainer);

                if (!selectedId) {
                    addButtonWrapper.style.display = 'none';
                    selectedProduct = null;
                    return;
                }

                if (type === 'sections') {
                    // загружаем подразделы
                    self.loadSections(selectedId, level + 1, params.iblockId, selectsContainer);

                    const labelText = self.getMessage('chooseSectionOrItem');
                    const loadingText = self.getMessage('loading');

                    // создаем новый дропдаун
                    const newSelectWrapper = document.createElement('div');
                    newSelectWrapper.className = 'custom-select-wrapper';
                    newSelectWrapper.dataset.level = level + 1;
                    newSelectWrapper.innerHTML = `
                        <label>${labelText}</label>
                        <div class="custom-select" data-level="${level + 1}">
                            <div class="custom-select-trigger">
                                <span>${loadingText}.</span>
                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="1.5"/>
                                </svg>
                            </div>
                            <div class="custom-select-dropdown"></div>
                        </div>
                    `;
                    selectsContainer.appendChild(newSelectWrapper);

                    addButtonWrapper.style.display = 'none';
                    selectedProduct = null;

                } else if (type === 'products') {
                    // выбран товар
                    selectedProduct = selectedId;
                    addButtonWrapper.style.display = 'block';
                }
            }
        });

        // обработчик кнопки добавления
        addButton.addEventListener('click', function() {
            if (!selectedProduct) return;

            const addingText = self.getMessage('adding');
            const addToCompareText = self.getMessage('addToCompare');
            const errorAddingText = self.getMessage('errorAdding');

            addButton.disabled = true;
            addButton.textContent = addingText;

            self.add(selectedProduct)
              .then(data => {
                  if (data.result && data.result.status) {
                      location.reload();
                  } else {
                      addButton.disabled = false;
                      addButton.textContent = addToCompareText;
                  }
              })
              .catch(error => {
                  console.error('Error adding product:', error);
                  addButton.disabled = false;
                  addButton.textContent = addToCompareText;
              });
        });
    }

    // переключение состояния дропдауна
    toggleDropdown(customSelect) {
        const isActive = customSelect.classList.contains('active');

        this.closeAllDropdowns();

        if (!isActive) {
            customSelect.classList.add('active');
            this.activeDropdown = customSelect;
        }
    }

    // закрытие конкретного дропдауна
    closeDropdown(customSelect) {
        customSelect.classList.remove('active');
        if (this.activeDropdown === customSelect) {
            this.activeDropdown = null;
        }
    }

    // закрытие всех дропдаунов
    closeAllDropdowns() {
        const allDropdowns = document.querySelectorAll('.custom-select.active');
        allDropdowns.forEach(dropdown => {
            dropdown.classList.remove('active');
        });
        this.activeDropdown = null;
    }

    loadSections(parentId, level, iblockId, selectsContainer) {
        const formData = new FormData();
        formData.append('action', 'getSections');
        formData.append('parentId', parentId);
        formData.append('iblockId', iblockId);
        formData.append('sessid', sessid);
        formData.append('lang', lang);

        fetch(this.urlRequest, {
            method: 'POST',
            body: formData
        })
          .then(response => response.json())
          .then(data => {
              if (data.result && data.result.items) {
                  this.populateSelect(level, data.result.items, data.result.type, selectsContainer);
              }
          })
          .catch(error => {
              console.error('Error loading sections:', error);
          });
    }

    populateSelect(level, items, type, selectsContainer) {
        const customSelect = selectsContainer.querySelector(`.custom-select[data-level="${level}"]`);
        if (!customSelect) return;

        const trigger = customSelect.querySelector('.custom-select-trigger span');
        const dropdown = customSelect.querySelector('.custom-select-dropdown');

        const placeholderKey = type === 'products' ? 'chooseProduct' : 'chooseSection';
        const placeholderText = this.getMessage(placeholderKey);

        // обновляем текст триггера
        trigger.textContent = `-- ${placeholderText} --`;

        // очищаем и заполняем дропдаун
        dropdown.innerHTML = '';

        items.forEach(item => {
            const option = document.createElement('div');
            option.className = 'custom-select-option';
            option.textContent = item.name;
            option.dataset.value = item.id;
            option.dataset.type = type;
            dropdown.appendChild(option);
        });
    }

    removeSelectsAfterLevel(level, selectsContainer) {
        const selects = selectsContainer.querySelectorAll('.custom-select-wrapper');
        selects.forEach(wrapper => {
            if (parseInt(wrapper.dataset.level) > level) {
                wrapper.remove();
            }
        });
    }

    add(productId) {
        return this.sendRequest({
            action: 'add',
            productId: productId
        }).then(response => {
            return response.json();
        });
    }

    remove(productId) {
        return this.sendRequest({
            action: 'refreshList',
            type: 'remove',
            productId: productId
        }).then(response => {
            return response.json();
        });
    }

    removeAll() {
        return this.sendRequest({
            action: 'refreshList',
            type: 'removeAll'
        }).then(response => {
            return response.json();
        });
    }

    sendRequest(data) {
        let formData = new FormData();
        formData.append('sessid', sessid);
        formData.append('lang', lang);

        if (Object.keys(data).length > 0) {
            for (let i in data) {
                if (data.hasOwnProperty(i))
                    formData.append(i, data[i]);
            }
        }

        return fetch(this.urlRequest, {body: formData, method: 'POST'});
    }

    compareFixedHead() {
        let self = this;
        const firstCol = document.querySelector('.compare-table__col');
        const fixedRow = document.querySelector('.compare-table__row-fixed');
        const compareInfo = document.querySelector('.compare-info');
        if (!firstCol || !fixedRow || !compareInfo) return;
        const colW = firstCol.getBoundingClientRect().width;
        const countCol = [...fixedRow.querySelectorAll('.compare-table__col')]
          .filter(col => getComputedStyle(col).display !== 'none').length;
        const rowFixedH = fixedRow.getBoundingClientRect().height;

        // функция для расчета позиции фиксации
        function calculateScrollThreshold() {
            const description = document.querySelector('.product-description');
            return description ? description.getBoundingClientRect().top + window.scrollY - 70 : 0;
        }

        // сохраняем изначальную позицию
        var scrollThreshold = calculateScrollThreshold();

        const updateBottom = () => {
            const bottom = document.querySelector('[data-container="bottom"]');
            if (bottom) self.scrollToLastRow = bottom.getBoundingClientRect().top + window.scrollY;
        };
        updateBottom();

        eventEmitter.on('compareChangeCategory', () => {
            updateBottom();
        });

        // отслеживаем изменения в блоке добавления товаров
        const addProductSection = document.querySelector('.add-product-section');
        if (addProductSection) {
            // используем MutationObserver для отслеживания изменений DOM
            const observer = new MutationObserver(function(mutations) {
                // Пересчитываем порог после изменения DOM
                scrollThreshold = calculateScrollThreshold();
            });

            observer.observe(addProductSection, {
                childList: true,      // следим за добавлением/удалением дочерних элементов
                subtree: true         // следим за всем поддеревом
            });
        }

        const updateFixedRow = () => {
            const currentScroll = window.scrollY;

            // используем сохраненный порог (который обновляется при изменениях)
            if (currentScroll > scrollThreshold) {
                fixedRow.classList.add('is-fixed');
                compareInfo.style.paddingTop = rowFixedH + 'px';
                fixedRow.style.transform = `translateX(${-compareInfo.scrollLeft}px)`;

                if (self.scrollToLastRow && currentScroll > self.scrollToLastRow) {
                    fixedRow.classList.add('hide')
                } else {
                    fixedRow.classList.remove('hide')
                }
            } else {
                fixedRow.classList.remove('is-fixed', 'hide');
                compareInfo.style.paddingTop = '0';
                fixedRow.style.transform = 'translateX(0)';
                fixedRow.style.width = '100%';
            }
        };
        window.addEventListener('scroll', updateFixedRow);

        compareInfo.addEventListener('scroll', () => {
            if (fixedRow.classList.contains('is-fixed')) updateFixedRow();
        });
    }
}